import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { Divider } from "@mui/material";
import { FaFileInvoice } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { FaClipboardList, FaTasks } from "react-icons/fa";
import { LayoutDashboard } from "lucide-react";
import { FaFileInvoiceDollar, FaShoppingCart, FaStoreAlt } from "react-icons/fa";
import { useCrm } from "../../../context/CrmContext";
import { imageBaseUrl } from "../../../utils/utils";

const CrmMobileSideBarUI = ({ onClose }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { user } = useCrm()

    const sideBarData = [
        //     {
        //     id: "dashboard",
        //     icon:  <LayoutDashboard />,
        //     label: "Dashboard",
        //     url: "/crm/dashboard" ,
        // },
        {
            id: "manageUsers",
            icon: <CreditCardIcon />,
            label: "Create Invoice",
            url: "/crm/create-invoice",
        },
        // {
        //     id: "allApplicants",
        //     icon: <PeopleAltIcon />,
        //     label: "Manage User",
        //     url: "/crm/users",
        // },
        {
            id: "manageInvoice",
            icon: <FaFileInvoice />,
            label: "Manage Invoice",
            url: "/crm/manage-invoice",
        },

        {
            id: "manageProduct",
            icon: <FaClipboardList />,
            label: "Manage Product",
            url: "/crm/manage-product",
        },
        {
            id: "addProduct",
            icon: <FaTasks />,
            label: "Add Product",
            url: "/crm/add-product",
        },
        // {
        //     id: "manageCustomer",
        //     icon: <GroupAddIcon />,
        //     label: "Manage Customer",
        //     url: "/crm/manage-customer",
        // },

        // {
        //     id: "purchaseOrder",
        //     icon: <FaClipboardList />,
        //     label: "Purchase Order",
        //     url: "/crm/purchase-order",
        // },


        //         {
        //             id: "manageItem",
        //             icon: <FaTasks />,
        //             label: "Manage Purchase Item",
        //             url: "/crm/manage-purchase-item",
        //         },
        //         {
        //             id: "managePurchaseOrder",
        //             icon: <FaFileInvoiceDollar />,
        //             label: "Manage Purchase Order",
        //             url: "/crm/manage-purchase-order",
        //         },
        //         {
        //             id: "manageDirectSales",
        //             icon: <FaShoppingCart />,
        //             label: "Manage Direct Sales",
        //             url: "/crm/manage-diract-sales",
        //         },
        //         {
        //             id: "manageIndirectSales",
        //             icon: <FaStoreAlt />,
        //             label: "Manage Indirect Sales",
        //             url: "/crm/manage-indiract-sales",
        //         },
    ];

    const handleNavigation = (url) => {
        navigate(url);
        if (onClose) onClose();
    };

    return (
        <Box
            sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <div className="flex flex-col justify-center pb-1 pl-8">
                {user?.profile_image ? (
                    <img
                        src={imageBaseUrl + "images/" + user.profile_image}
                        className="w-[80px] h-[80px] object-cover pt-4"
                        alt="Logo"
                    />
                ) : (
                    <div className="text-white text-[30px] uppercase font-bold">
                        {user?.companyName}
                    </div>
                )}
            </div>            <Divider sx={{ backgroundColor: "#ffffff" }} />
            <div className="text-[#145348] text-[25px] font-bold pl-5 pb-1">AMBER SILK MILS</div>
            <Divider sx={{ backgroundColor: "#ffffff" }} />

            <List>
                {sideBarData.map((item) => (
                    <ListItem key={item.id} disablePadding>
                        <ListItemButton
                            onClick={() => handleNavigation(item.url)}
                            sx={{
                                backgroundColor:
                                    location.pathname === item.url
                                        ? "#23806D"
                                        : "transparent",

                                borderRadius: "4px",
                                margin: "4px 8px",
                            }}
                        >
                            <item.icon.type
                                className={`${location.pathname === item.url
                                    ? "text-white"
                                    : "text-black"
                                    }`}
                            />
                            <ListItemText
                                primary={item.label}
                                sx={{
                                    color:
                                        location.pathname === item.url
                                            ? "#ffffff"
                                            : "black",
                                    paddingLeft: "8px",
                                }}
                            />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    );
};

export default CrmMobileSideBarUI;
